import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { WrapperHttpService } from '../../../services/wrapper-http-service';
import { API_URL } from '../../../../services/config';
import { SapEtaConfigurationEndpoint } from './constants/sap-eta-configuration-endpoint';
import { SapEtaItemModel } from './models/sap-eta.model';

@Injectable({
  providedIn: 'root',
})
export class SapEtaConfigurationService {
  constructor(private http: WrapperHttpService) {}

  getList(): Observable<SapEtaItemModel[]> {
    return this.http
      .withLoading()
      .get<SapEtaItemModel[]>(
        `${API_URL}${SapEtaConfigurationEndpoint.Base}${SapEtaConfigurationEndpoint.AccessProperties}`,
      );
  }

  create(body: SapEtaItemModel): Observable<void> {
    return this.http
      .withLoading()
      .post<void>(`${API_URL}${SapEtaConfigurationEndpoint.Base}${SapEtaConfigurationEndpoint.AccessProperties}`, body);
  }

  update(body: SapEtaItemModel): Observable<void> {
    return this.http
      .withLoading()
      .put<void>(`${API_URL}${SapEtaConfigurationEndpoint.Base}${SapEtaConfigurationEndpoint.AccessProperties}`, body);
  }

  delete(id: string): Observable<void> {
    return this.http
      .withLoading()
      .delete<void>(
        `${API_URL}${SapEtaConfigurationEndpoint.Base}${SapEtaConfigurationEndpoint.AccessProperties}/${id}`,
      );
  }

  pushShipments(id: string): Observable<void> {
    return this.http
      .withLoading()
      .post<void>(
        `${API_URL}${SapEtaConfigurationEndpoint.Base}${SapEtaConfigurationEndpoint.AccessProperties}${SapEtaConfigurationEndpoint.ManualPush}/${id}`,
        {},
      );
  }
}
